// 地圖相關常數配置
export const TYPE_MAP = {
  solarInfo: '太陽能',
  mysqlInfo: '儲能',
  powerInfo: '用電'
}

// 縣市標籤偏移配置
export const LABEL_OFFSETS = {
  '屏東縣': { x: -12, y: -10 },
  '基隆市': { x: 20, y: -12 },
  '台北市': { x: -12, y: 0 },
  '新北市': { x: 0, y: 20 },
  '桃園市': { x: -11, y: -10 },
  '新竹市': { x: -13, y: 2 },
  '苗栗縣': { x: -10, y: 2 },
  '台中市': { x: -25, y: 10 },
  '嘉義市': { x: -12, y: 3 },
  '嘉義縣': { x: 23, y: 5 },
  '台南市': { x: 0, y: 5 },
  '高雄市': { x: 8, y: 3 },
  '宜蘭縣': { x: 0, y: 5 },
  '花蓮縣': { x: 5, y: 0 },
  '澎湖縣': { x: 0, y: 20 },
  '連江縣': { x: 0, y: 20 },
  '金門縣': { x: 0, y: 25 }
}

// 地圖中心點配置（根據視窗寬度）
export const getMapCenter = (windowWidth) => {
  if (windowWidth <= 375) {
    return { x: 85, y: 190 }
  } else if (windowWidth <= 576) {
    return { x: 155, y: 180 }
  } else if (windowWidth <= 768) {
    return { x: 250, y: 150 }
  } else if (windowWidth <= 1024) {
    return { x: 340, y: 190 }
  } else if (windowWidth <= 1280) {
    return { x: 456, y: 230 }
  } else if (windowWidth <= 1440) {
    return { x: 530, y: 220 }
  } else if (windowWidth <= 1920) {
    return { x: 145, y: 295 }
  } else if (windowWidth <= 2560) {
    return { x: 190, y: 390 }
  } else {
    return { x: 145, y: 295 }
  }
}

// 地圖縮放比例配置
export const getMapScale = (windowWidth, width, height, dx, dy) => {
  if (!width || !height || !dx || !dy || dx === 0 || dy === 0) {
    return 1.3
  }

  // 先計算SVG區域與地圖邊界的最小縮放比例
  const baseScale = Math.min(width / dx, height / dy)

  if (!isFinite(baseScale)) return 1 // 若分母出現0或無窮大，預設縮放

  if (windowWidth <= 375) {
    return baseScale * 1.2
  } else if (windowWidth <= 576) {
    return baseScale * 1.15
  } else if (windowWidth <= 768) {
    return baseScale * 1.15
  } else if (windowWidth <= 1024) {
    return baseScale * 1.2
  } else if (windowWidth <= 1280) {
    return baseScale * 1.25
  } else if (windowWidth <= 1440) {
    return baseScale * 1.2
  } else {
    return baseScale * 1.3
  }
}

// 進度顏色配置
export const getProgressColor = (percent) => {
  if (percent >= 80) return '#87B047' // 綠色：穩定運作中
  if (percent >= 50) return '#E7A961' // 黃色：運作良好但有輕微異常
  if (percent >= 20) return '#F8872A' // 橘色：運作不穩定
  return '#DB3D3D' // 紅色：無法運作
}

export const getDisconnectedColor = (percent) => {
  if (percent >= 1) return '#373A4B'
  if (percent >= 0) return '#DB3D3D' // 無法運作
}

// Tooltip 偏移配置
export const TOOLTIP_OFFSETS = {
  PARENT: { x: -160, y: 100 },
  CHILD: { x: -72, y: 100 }
}

// 聚類配置
export const CLUSTER_CONFIG = {
  THRESHOLD: 15, // 增加聚類距離，讓更多站點聚在一起
  COLLISION_RADIUS: 3,
  ICON_RADIUS: 2
}

// 圖標配置
export const ICON_CONFIG = {
  BASE_RADIUS: 1.5,
  ICON_CENTER: 2,
  BORDER_WIDTH: 0.6,
  MIN_SIZE: 0.6,
  MAX_SIZE: 1.6,
  DENSITY_SEARCH_RADIUS: 20,
  DENSITY_THRESHOLD: 5
}

// 標籤配置
export const LABEL_CONFIG = {
  BASE_DISTANCE: 8,
  MIN_DISTANCE: 12,
  PADDING: 0.3,
  TEXT_HEIGHT: 1.2
}

// 動畫配置
export const ANIMATION_CONFIG = {
  ICON_EXPAND_DURATION: 400,
  ICON_COLLAPSE_DURATION: 300,
  LABEL_FADE_DURATION: 400,
  LABEL_HIDE_DURATION: 300,
  STAGGER_DELAY: 100
}
